import { updateStationMutation } from '../requests';
import { gql } from '@/setup/api';
import { debounceReduce } from '../../helpers';

export const updateStation = async (
  { commit, dispatch, getters },
  {
    station,
    loadingField = 'updateStation',
    cancelKey = 'updateStation',
    withoutMiddleware = false,
  },
) => {
  commit('startLoading', loadingField);
  // format input for backend
  const stationToSave = {
    ...station,
    playingId: station.playing && station.playing.id,
  };
  delete stationToSave.playing;
  let data = null;
  await updateStationMutation(stationToSave, {
    cancelKey,
    withoutMiddleware,
  }).then(result => {
    data = result;
    const { station } = result;
    if (station.playingType === 'tutorial') {
      station.playing._tutorial = true;
    }
    dispatch('updateStationLocally', {
      ...station,
      _lastSyncedAt: Date.now(),
    }); // hydrate local state with truth from server
  }).catch(e => {
    // The first call might be unauthorized, so don't spam Sentry with 403 errors
    if (e.name !== 'FetchError' || e.originalError?.response?.errors[0].message !== '403 - Authentication Error: You are not logged in.') {
      throw e;
    }
  });
  commit('endLoading', loadingField);
  return data;
};

export const updateStationWithDebounce = debounceReduce(
  updateStation,
  700,
  ([, previousPayload] = [null, { station: {} }], [store, payload, opts]) => {
    return [
      store,
      {
        ...payload,
        station: {
          ...previousPayload.station,
          ...payload.station,
        },
      },
      opts,
    ];
  },
);

export const updateStationWithOptimistic = async (
  { commit, dispatch, getters },
  { payload, loadingField },
) => {
  const { stationId } = getters;
  const station = {
    id: stationId,
    ...payload,
  };
  gql.cancelLast('updateStation');
  gql.cancelLast('getStation');
  dispatch('updateStationLocally', station); // optimistic update
  dispatch('updateStationWithDebounce', { station, loadingField });
};

export const updateStationLocally = async ({ getters, dispatch }, payload) => {
  const { stationId } = getters;
  const station = {
    id: stationId,
    ...payload,
  };
  return dispatch('insertEntities', { name: 'Station', payload: station }); // optimistic update
};
